// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"840":"8dc71c3a","846":"4c4043f8","995":"8f094a37"}[chunkId] + ".css";
};